import { motion } from 'framer-motion';

export const SubsidiesHero = () => (
  <section className="py-24 bg-gradient-to-br from-[#f8fafc] via-white to-[#f8fafc]" data-testid="subsidies-hero">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center max-w-3xl mx-auto"
      >
        <span className="inline-block px-4 py-2 bg-gradient-to-r from-[#3b5998]/10 to-[#00bcd4]/10 rounded-full text-sm font-medium text-[#3b5998] mb-6 border border-[#3b5998]/20">
          Government Subsidies
        </span>
        <h1 className="font-heading text-4xl sm:text-5xl font-semibold text-[#0f172a] leading-tight mb-6">
          Unlock Financial Benefits for
          <span className="gradient-text block">Your Business Growth</span>
        </h1>
        <p className="text-lg text-[#64748b] leading-relaxed">
          Navigate government subsidy schemes with expert guidance. We help you identify, 
          apply, and secure the right incentives for your business.
        </p>
      </motion.div>
    </div>
  </section>
);
